module.exports = __webpack_public_path__ + "img/tertiary_6x3_z18.c70e34d9.svg";